import React from 'react'

import PropTypes from 'prop-types'
import { useConnect } from 'redux-bundler-hook'

import FileCard from './File'
import ImageCard from './Image'

export const AttachmentCardComponent = props => (props?.mimetype.startsWith('image') ? (
  <ImageCard {...props} />
) : (
  <FileCard {...props} />
))

AttachmentCardComponent.propTypes = {
  mimetype: PropTypes.string.isRequired,
}

const Wrapped = React.memo(props => {
  const { me } = useConnect('selectMe')
  return <AttachmentCardComponent {...props} me={me} />
})

export default Wrapped
